export const STRIPE_ENV = process.env.STRIPE_PUBLIC_APIKEY.indexOf('pk_test_') > -1 ? 'test' : 'live'
